import {
  ChangeDetectorRef,
  Component,
  inject,
  ChangeDetectionStrategy
} from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle
} from '@angular/material/dialog';
import { MatButton } from '@angular/material/button';
import { Router } from '@angular/router';

import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatCheckbox } from '@angular/material/checkbox';

export interface AlertData {
  header: string;
  message: string;
  buttonText: string;
  page: string | undefined;
  checkboxMessage?: string;
  checkboxCheckedCallback?: () => void;
}

@Component({
  selector: 'app-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatButton,
    MatCheckbox,
    ReactiveFormsModule
  ]
})
export class AlertComponent {
  readonly alertData = inject<AlertData>(MAT_DIALOG_DATA);
  checkboxControl: FormControl<boolean | null> = new FormControl(null);
  constructor(
    private dialogRef: MatDialogRef<AlertComponent>,
    private router: Router,
    private changeDetectorRef: ChangeDetectorRef
  ) {
    setTimeout(() => this.changeDetectorRef.detectChanges(), 100);
  }

  onButtonClick(): void {
    if (
      this.showCheckbox &&
      !!this.alertData.checkboxCheckedCallback &&
      this.checkboxControl.value
    ) {
      this.alertData.checkboxCheckedCallback();
    }
    if (this.alertData.page !== undefined) {
      void this.router.navigate(['/' + this.alertData.page]);
    }
    this.dialogRef.close();
  }

  get showCheckbox(): boolean {
    return !!this.alertData.checkboxMessage;
  }
}
